import { message, Space } from "antd";
import React, { useContext } from "react";
import { createContext } from "react";
import { useSelector } from "react-redux";

const ErrorContext = createContext();

export const ErrorsHandlerProvider = ({ children }) => {
  const errors = useSelector((state) => state.errorsHandlerReducer.errorsData);

  if (errors) {
    if (errors.code === "ONLINE") {
      message.success(errors.message);
    }

    if (errors.code === "OFFLINE") {
      message.error(
        <Space>
          <div>{errors.message}</div>
        </Space>,
        5
      );
    }

    if (["401", "403", "502", "FE"].includes(errors.code)) {
      message.error(
        <Space>
          {errors.message === undefined ? (
            <div>The server did not return an error message</div>
          ) : (
            <div>{errors.message}</div>
          )}
        </Space>,
        5
      );
    }

    if (errors.code === "BE") {
      if (errors.message.length > 1) {
        errors.message.map((err) =>
          message.error(
            <Space>
              {err.code === undefined && err.message === undefined ? (
                <div>The server did not return an error message</div>
              ) : (
                <div>{`Error ${err.code}: ${err.message}`}</div>
              )}
            </Space>,
            5
          )
        );
      } else {
        message.error(
          <Space>
            {errors.message[0].code === undefined &&
            errors.message[0].message === undefined ? (
              <div>The server did not return an error message</div>
            ) : (
              <div>{`Error ${errors.message[0].code}: ${errors.message[0].message}`}</div>
            )}
          </Space>,
          5
        );
      }
    }
  }

  return <ErrorContext.Provider>{children}</ErrorContext.Provider>;
};

export const useErrorHandler = () => useContext(ErrorContext);
